import axios from 'axios';
import { apiURLPrint } from 'global_config/constant-global';
import moment from 'moment';
import { logAuditTrailEvent } from 'services/system_setup/auditTrail';

const MODULE_CODE = 'dr';

function logDeliveryAction(action, description, payload, isSuccess = 1) {
	void logAuditTrailEvent({
		moduleCode: MODULE_CODE,
		subModuleCode: 'delivery',
		action,
		description,
		payload,
		isSuccess,
	});
}

function normalizeDeliveryTransactionAction(header = {}) {
	const submitValue = String((header && header.submit_val) || '').trim().toUpperCase();
	const statusValue = String((header && header.status) || '').trim().toUpperCase();

	if (submitValue === 'POST') return 'POST';
	if (submitValue === 'CANCEL') return 'CANCEL';
	if (statusValue === 'POSTED') return 'POST';
	if (statusValue === 'CANCELLED') return 'CANCEL';
	return 'SAVE';
}

function buildDeliveryAuditSnapshot(header = {}, details = []) {
	const submitValue = String((header && header.submit_val) || '').trim().toUpperCase();
	let targetStatus = 'NEW';

	if (submitValue === 'POST') targetStatus = 'POSTED';
	if (submitValue === 'CANCEL') targetStatus = 'CANCELLED';

	return {
		transaction_type: 'DELIVERY',
		transaction_no: (header && (header.DrNo || header.dr_no)) || '',
		dr_no: (header && (header.DrNo || header.dr_no)) || '',
		submit_val: (header && header.submit_val) || '',
		previous_status: (header && header.status) || '',
		target_status: targetStatus,
		customer_id: (header && header.customer_id) || null,
		total_amount: (header && header.totalAmount) || '',
		detail_count: Array.isArray(details) ? details.length : 0,
	};
}

export async function fetchDeliveryNoAPI(drNum) {
	let deliverynolist = [];
	
	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}delivery/drno/${drNum}`,
			// data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});

		const { data } = response;
		deliverynolist = data;
	}
	catch(error) {
		throw error;
		// Message.error();
	}

	return deliverynolist;
}


//can be used to search 
export async function fetchDeliveryReceipts(payload) {
	let deliveryreceiptslist = [];

	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}delivery/search`,
			data: payload,
			headers: {
				'content-type': 'application/json',
			},
		});
        console.log("🚀 ~ file: fetch_customers.jsx ~ line 15 ~ fetchCustomers ~ response", response)

		const { data } = response;
		deliveryreceiptslist = data;
	} catch (error) {
		throw error;
		// Message.error();
	}

	return deliveryreceiptslist;
}

// search delivery api

export async function searchDeliveryAPI(payload) {
	
	if(payload.dr_date !== undefined && payload.dr_date !== null){
		if(Array.isArray(payload.dr_date) && payload.dr_date.length === 0){
			payload.dr_date = undefined;
		}
	}

	const DrNo = payload.dr_no === undefined ? '' : payload.dr_no;
	const Customers = payload.customer === undefined ? '' : payload.customer;
	const FromDate = (payload.dr_date === undefined || payload.dr_date === null || !Array.isArray(payload.dr_date) || payload.dr_date.length === 0) 
		? '' : moment(payload.dr_date[0]).format('MM-DD-YYYY');
	const ToDate = (payload.dr_date === undefined || payload.dr_date === null || !Array.isArray(payload.dr_date) || payload.dr_date.length === 0) 
		? '' : moment(payload.dr_date[1]).format('MM-DD-YYYY');

	let deliveryList = [];

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}delivery/search/?dr_no=${DrNo}&customer=${Customers}&start_date=${FromDate}&end_date=${ToDate}`,
			data: payload,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		deliveryList = data;
	} 
	catch(error) {
		logDeliveryAction('SEARCH', 'Delivery search failed', { request: payload, error: error && error.message }, 0);
		throw error;
		// Message.error();
	}
	
	logDeliveryAction('SEARCH', 'Delivery search', { request: payload, resultCount: deliveryList.length }, 1);
	return deliveryList;
}

//create delivery api
export async function createDeliveryAPI(Header, Details) {
	console.log("apidata", Header);
	console.log("apidatadetails", Details);
	let deliveryData = [];
	const action = normalizeDeliveryTransactionAction(Header);
	const snapshot = buildDeliveryAuditSnapshot(Header, Details);
	const transactionLabel = snapshot.dr_no ? ` ${snapshot.dr_no}` : '';
	try{
		const axiosResponse = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}delivery/create/`,
			data: {Header, Details}
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		deliveryData = axiosResponse;
	} 
	catch(error) {
		logDeliveryAction(action, `${action} delivery${transactionLabel} failed`, { ...snapshot, error: error && error.message }, 0);
		throw error;
		// Message.error();
	}
	
	logDeliveryAction(action, `${action} delivery${transactionLabel}`, snapshot, 1);
	return deliveryData;
}


//update delivery api
export async function updateDeliveryAPI(Header, Details) {
	let updateDelivery = [];
	const action = normalizeDeliveryTransactionAction(Header);
	const snapshot = buildDeliveryAuditSnapshot(Header, Details);
	const transactionLabel = snapshot.dr_no ? ` ${snapshot.dr_no}` : '';
	try{
		const axiosResponse = await axios({
			method: 'PUT',
			url: `${process.env.REACT_APP_BACKEND_API}delivery/update/`,
			data: {Header, Details}
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		updateDelivery = axiosResponse;
	} 
	catch(error) {
		logDeliveryAction(action, `${action} delivery${transactionLabel} failed`, { ...snapshot, error: error && error.message }, 0);
		throw error;
		// Message.error();
	}
	
	logDeliveryAction(action, `${action} delivery${transactionLabel}`, snapshot, 1);
	return updateDelivery;
}


//delivery_receipt details
export async function fetchDeliveryDetailsAPI(dr_id) {
	let deliverydetails = [];
	
	try{
		const response = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}delivery/deliverydetails`,
			data: { dr_id },
			headers: { 
				'content-type': 'application/json',
			}
		});

		const { data } = response;
		deliverydetails = data;
	}
	catch(error) {
		logDeliveryAction('VIEW', 'View delivery details failed', { request: { dr_id }, error: error && error.message }, 0);
		throw error;
		// Message.error();
	}

	logDeliveryAction('VIEW', 'View delivery details', { request: { dr_id } }, 1);
	return deliverydetails;
}



//DR list
export async function fetchDrListAPI() {
	let drlist = null;
	
	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}delivery/drlist`,
			// data: {  },
			headers: { 
				'content-type': 'application/json',
			}
		});

		const { data } = response;
		drlist = data;
	}
	catch(error) {
		throw error;
		// Message.error();
	}

	return drlist;
}

//customers details
export async function fetchCustomerDetailsAPI(customer_id) {
	let customersdetails = null;
	
	try{
		const response = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}delivery/customersdetails`,
			data: { customer_id },
			headers: { 
				'content-type': 'application/json',
			}
		});

		const { data } = response;
		customersdetails = data;
	}
	catch(error) {
		throw error;
		// Message.error();
	}

	return customersdetails;
}

//delete details
export async function deleteDrDetailsAPI(dr_line_id) {
	let deldrdetail = null;
	
	try{
		const response = await axios({
			method: 'DELETE',
			url: `${process.env.REACT_APP_BACKEND_API}delivery/deldrdetail`,
			data: { dr_line_id },
			headers: { 
				'content-type': 'application/json',
			}
		});

		const { data } = response;
		deldrdetail = data;
	}
	catch(error) {
		logDeliveryAction('DELETE', 'Delete delivery detail line failed', { request: { dr_line_id }, error: error && error.message }, 0);
		throw error;
		// Message.error();
	}

	logDeliveryAction('DELETE', 'Delete delivery detail line', { request: { dr_line_id } }, 1);
	return deldrdetail;
}

export async function generateDeliveryReport (payload){
	let details = null;
	
	try {
		const response = await axios({
			method: 'POST',
			// url: `${apiURLPrint}grp_reports/generate.php`,
			//url: `https://grp.dxvista.com/reports/jrprintform/grp/deliveryreceipt/PRT_DR.jrxml`,
			url: `${process.env.REACT_APP_REPORTS_API}deliveryreceipt/PRT_DR.jrxml`,
			data: JSON.stringify( payload ),
			headers: { 
			 	'Content-Type': 'application/json',
				'Access-Control-Allow-Origin':'*'
			}
		});
			

		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
	}
	return details;
}


//delivery header
export async function fetchDeliveryHeaderAPI(dr_no) {
	let deliveryHeader = [];
	
	try{
		const response = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}delivery/deliveryno`,
			data: { dr_no },
			headers: { 
				'content-type': 'application/json',
			}
		});

		const { data } = response;
		deliveryHeader = data;

		console.log('deliveryHeader =>', deliveryHeader);
	}
	catch(error) {
		throw error;
		// Message.error();
	}

	return deliveryHeader;
}

export const fetchAvailableDrList = async () =>{ 
	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}delivery/listFreeDr`,
			headers: { 
				'content-type': 'application/json',
			}
		});

		const { data } = response;

		return data;

	} catch (error) {
		throw error;	
	}
}
//create printed trxn
export async function drPrintedTrxnAPI(Data) {
	let result = [];
	try{
		const axiosResponse = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}printedtrxn/create/`,
			data: Data
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		result = axiosResponse;
	} 
	catch(error) {
		throw error;
	}
	
	return result;
}
